export const separateByChunks = (array, max) => {
  const result = [];

  for (let i = 0; i < array.length; i += max) {
    result.push(array.slice(i, i + max));
  }

  return result;
};
